export default __webpack_public_path__ + "static/media/img_baseBunny_green_p.ed0fdd35.jpg";